module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-data-7a3c1b84.svg";